import axios from "axios";
import serverHost from "./serverHost";
import { getUserToken } from "../auth";
const TOKEN_KEY = "@PERTO-TEACHERS-WEB-ACCESS-TOKEN";

export default {
  get(route, data, config = {}) {
    return request("get", route, data, config);
  },
  post(route, data, config = {}) {
    return request("post", route, data, config);
  },
  put(route, data, config = {}) {
    return request("put", route, data, config);
  },
  delete(route, data, config = {}) {
    return request("delete", route, data, config);
  },
};

const request = async (method = "post", url, data, config = {}) => {
  const tokenAcesso = await getUserToken();

  const api = axios.create({
    baseURL: serverHost(true),
    timeout: 90000,
  });

  return new Promise((resolve, reject) => {
    api({
      headers: config.formData
        ? { authorization: tokenAcesso, "Content-Type": "multipart/form-data" }
        : { authorization: tokenAcesso },
      method,
      url,
      data: method === "get" ? undefined : data,
      params: method === "get" ? data : undefined,
    })
      .then((res) => {
        //alert(JSON.stringify(res.data))
        resolve(res.data);
      })
      .catch((err) => {
        console.log(err.toString());

        if (!err.response) return reject({ status: 500 });

        const { status, data } = err.response;

        if (status === 401) {
          localStorage.removeItem(TOKEN_KEY);

          alert("Sessão expirada. Refaça o login para reestabelecer o acesso.");
          return window.location.replace("/login?sessionTimeout=1");
        }

        reject({ status, data });
      });
  });
};
